<template>
  <div>
    <CRow class="justify-content-between mb-3">
      <CCol sm="auto"
        ><div class="ui-type-display-lg">
          {{ $t("family.market.cart.title") }}
        </div></CCol
      >
    </CRow>

    <div class="loading text-center" v-if="loading">
      <CSpinner color="primary" size="lg" />
    </div>
    <CRow v-else-if="markets.length > 0">
      <MarketCart
        v-for="market in markets"
        :key="market.id"
        :market="market"
        :loadProducts="loadProducts(market)"
      />
    </CRow>
    <div v-else>{{ $t("family.market.cart.nocarts") }}</div>
  </div>
</template>

<script>
import get from "lodash/get";
import { MarketCart } from "./partials";
import { mapGetters, mapState } from "vuex";
import { apiGet } from "../../helpers/apiHelper";

export default {
  name: "UiMarketCarts",
  components: {
    MarketCart,
  },

  data() {
    return {
      initialized: false,
      loading: false,
      markets: [],
    };
  },

  computed: {
    ...mapState("shop", ["market"]),

    ...mapGetters("connections", ["familyId"]),
  },

  async mounted() {
    this.initialized = true;
    await this.getMarkets();
  },

  methods: {
    async getMarkets() {
      this.loading = true;
      const response = await apiGet("family_markets", [this.familyId], null);
      if (response && response.status === 200) {
        const data = response.data.payload.Items;
        this.markets = data.filter((market) => market.cart !== null);
        this.loading = false;
      } else {
        this.$store.dispatch("toaster/add", {
          title: this.$t("role.finance.invoicesSettings.attention"),
          text: "Error loading carts",
          color: "danger",
          autohide: true,
        });
        this.loading = false;
      }
    },

    loadProducts(market) {
      return (
        this.markets.length === 1 ||
        market.market.id === get(this.market, "market.id", null)
      );
    },
  },
};
</script>
